import { render, staticRenderFns } from "./PixelLog.vue?vue&type=template&id=3a1fb397&"
import script from "./PixelLog.vue?vue&type=script&lang=js&"
export * from "./PixelLog.vue?vue&type=script&lang=js&"
import style0 from "./PixelLog.vue?vue&type=style&index=0&id=3a1fb397&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports